

















import { Watch, Prop, Component, Vue } from "vue-property-decorator";
import { Company, Office, getOurCompanies } from "@/api/company-api";
import { StaffTableItem } from "@/components/VStaffTable.vue";

import CompanyShow from "@/templates/CompanyShow.vue";
import { addServiceUserStaff /*inviteToService */ } from "@/api/invitation-api";
import { ServiceUser, getServiceUsers } from "@/api/service-api";
import InvitableStaffSpec from "../../models/specs/InvitableStaffSpec";

@Component({
  components: {
    CompanyShow
  }
})
export default class OfficeShowPage extends Vue {
  @Prop({ required: true }) id!: string;
  query = "";

  company: Company | null = null;
  office: Office | null = null;
  staffs: StaffTableItem[] = [];

  edit() {
    const params = { id: this.id };
    this.$router.push({ name: "office-edit", params });
  }
  search(query: string) {
    this.query = query;
  }

  cancel() {
    this.$router.push({ name: "office-list" });
  }

  createStamp() {
    const params = {
      companyId: this.id,
      officeId: this.office && this.office.officeId
    };

    if (
      this.office &&
      this.office.stampList &&
      this.office.stampList.length > 0
    ) {
      const params = {
        companyId: this.id,
        officeId: this.office && this.office.officeId,
        id: String((this.office.stampList[0] as any).stampId)
      };
      this.$router.push({ name: "office-stamp-edit", params });
      return;
    }
    this.$router.push({ name: "office-stamp-new", params });
  }

  createStaff() {
    const params = { companyId: this.id };
    this.$router.push({ name: "office-staff-new", params });
  }

  selectStaff(id: number) {
    const params = { companyId: this.id, id: String(id) };
    this.$router.push({ name: "office-staff-edit", params });
  }

  async inviteStaff(id: number) {
    /* [BRV-15] LAMNK - Update invite staff */

    if (!this.company) return;
    const s = this.company.office.staffList.find(s => s.staffId === id);
    if (!s) return;
    try {
      await addServiceUserStaff(s.staffId);
    } catch (e) {
      alert(e);
      return;
    }
    await this.initServiceUsers();
    await this.initCompanies();
    /* [BRV-15] LAMNK - Update invite staff END */

    /** Comment code below due to decapred  */
    /* console.log(id)
    if (!this.company) return;
    const s = this.company.office.staffList.find(s => s.staffId === id);
    console.log(s)
    if (!s) return;
    await inviteToService(s.staffId, s.mail);
    await this.initServiceUsers(); */
  }

  private companies: Company[] = [];
  private serviceUsers: ServiceUser[] = [];

  private get staffItems(): StaffTableItem[] {
    if (!this.query) return this.staffs;
    return this.staffs.filter(s => s.name.includes(this.query));
  }

  private get invitableSpec() {
    return new InvitableStaffSpec(this.serviceUsers);
  }

  private async created() {
    await this.initServiceUsers();
    await this.initCompanies();
  }

  private async initCompanies() {
    this.companies = await getOurCompanies();
    this.selectCompany();
  }

  private async initServiceUsers() {
    this.serviceUsers = await getServiceUsers();
  }

  @Watch("id")
  private selectCompany() {
    const c = this.companies.find(c => String(c.companyId) === this.id);
    if (c) {
      this.company = { ...c };
      this.office = { ...c.office };
      this.staffs = c.office.staffList.map(
        s => new StaffTableItem(s, c, this.invitableSpec.isSatisfied(s))
      );
    } else {
      this.company = null;
      this.office = null;
      this.staffs = [];
    }
  }
}
